<template>
  <ul v-bind="context.attributes" class="color-switch-list">
    <li
      v-for="(option, index) in context.options"
      :key="index"
      :class="{ active: context.model === option.value }"
    >
      <div
        :style="{ backgroundColor: option.color }"
        @click="context.model = option.value"
      >
      <font-awesome-icon
        v-if="context.model === option.value"
        icon="check"
        style="color:green"
      />
      </div>
    </li>
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
    <li class="placeholder" />
  </ul>
</template>
<script>
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>
<style scoped>
ul.color-switch-list {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0px 10px;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
}
ul.color-switch-list li {
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}
ul.color-switch-list li > div {
  width: 100%;
  height: 70px;
  object-fit: contain;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 1px;
  border-radius: 3px;
}
ul.color-switch-list li svg {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
ul.color-switch-list li.placeholder {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ColorSwitch.vue